import { LOCALE } from '@/constants/locale.constants';
import { get } from 'lodash-es';

/**
 * 주의 "언어-국가코드" 구분자는 "언어_국가코드" 변환합니다.
 */
export function getBrowserLanguages() {
  var languages = get(navigator, 'languages', null);
  if (!languages) {
    var _get;
    languages = [(_get = get(navigator, 'language', null)) !== null && _get !== void 0 ? _get : LOCALE.EN_US];
  }
  return languages.map(function (language) {
    return language.replace('-', '_');
  });
}
function toLanguage(language) {
  var newLanguage = language;
  if (language.includes('_')) {
    newLanguage = language.split('_')[0];
  }
  if (language.includes('-')) {
    newLanguage = language.split('-')[0];
  }
  return newLanguage.toLowerCase();
}
var SUPPORT_LANGUAGE_LOCALE = {
  en: LOCALE.EN_US,
  ko: LOCALE.KO_KR,
  ja: LOCALE.JA_JP,
  zh: LOCALE.ZH_CN
};
export function getSupportLanguage() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getBrowserLanguages();
  var defaultLanguage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LOCALE.EN_US;
  var languages = Array.isArray(language) ? language.map(toLanguage) : [toLanguage(language)];
  var target = languages.find(function (language) {
    return Boolean(SUPPORT_LANGUAGE_LOCALE[language]);
  });
  return target ? SUPPORT_LANGUAGE_LOCALE[target] : defaultLanguage;
}